import wsjLogo from '@/assets/logos/wsj.png';
import entrepreneurLogo from '@/assets/logos/entrepreneur.png';
import huffpostLogo from '@/assets/logos/huffpost.png';
import fastCompanyLogo from '@/assets/logos/fast-company.png';
import usaTodayLogo from '@/assets/logos/usa-today.png';
import forbesLogo from '@/assets/logos/forbes.png';
import nbcLogo from '@/assets/logos/nbc.png';
import abcLogo from '@/assets/logos/abc.png';
import cbsLogo from '@/assets/logos/cbs.png';
import foxLogo from '@/assets/logos/fox.png';

interface Publication {
  name: string;
  src: string;
}

const LogoMarquee = () => {
  const publications: Publication[] = [
    { name: 'Wall Street Journal', src: wsjLogo },
    { name: 'Entrepreneur', src: entrepreneurLogo },
    { name: 'HuffPost', src: huffpostLogo },
    { name: 'Fast Company', src: fastCompanyLogo },
    { name: 'USA Today', src: usaTodayLogo },
    { name: 'Forbes', src: forbesLogo },
    { name: 'NBC', src: nbcLogo },
    { name: 'ABC', src: abcLogo },
    { name: 'CBS', src: cbsLogo },
    { name: 'Fox', src: foxLogo },
  ];

  const LogoImage = ({ pub }: { pub: Publication }) => (
    <img
      src={pub.src}
      alt={pub.name}
      width={120}
      height={40}
      loading="lazy"
      decoding="async"
      className="h-8 md:h-10 w-auto object-contain grayscale brightness-0 invert opacity-60 hover:opacity-100 transition-opacity duration-300"
    />
  );

  return (
    <section className="py-12 border-y border-border bg-muted/30 overflow-hidden">
      <div className="container mx-auto px-6">
        <p className="text-center text-sm text-muted-foreground mb-8 uppercase tracking-widest">
          As Featured In
        </p>
        <div className="relative overflow-hidden">
          {/* Gradient masks for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-muted/30 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-muted/30 to-transparent z-10 pointer-events-none" />
          
          {/* Scrolling container */}
          <div className="flex animate-marquee">
            {/* First set of logos */}
            {publications.map((pub) => (
              <div
                key={pub.name}
                className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center"
              >
                <LogoImage pub={pub} />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {publications.map((pub) => (
              <div
                key={`${pub.name}-duplicate`}
                className="flex-shrink-0 mx-8 md:mx-12 flex items-center justify-center"
              >
                <LogoImage pub={pub} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
